import {Modal, Tabs} from 'antd'
import {course_getCourseClassStudents_Api} from 'apis'
import {getId} from 'apis/model/base'
import {renderMetadata} from 'components/DynamicFields/functions/renderMetadata'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import {createModalTitle} from 'components/renderFunctions/createModalTitle'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {AiOutlineAudit} from 'react-icons/ai'
import {withProps} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, renderIf,} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {renderCourseClassStudent} from 'views/Workspace/Course/functions/renderCourseClassStudent'
import {FetchStudentById} from '../../components/FetchEntity'
import CourseClassContext from '../../CourseClassContext'
import {StudentActionTypes} from '../../index'
import {CourseClassStudentAttendantsForm} from '../CourseClassAttendanceForm'
import classNames from "classnames";
import {renderIfElse} from "../../../../Shared";
import ImageLoader from "../../../../../components/ImageLoader";
import EmptyHolder from "../../../../../components/EmptyHolder";
import {CourseClassStudentUpdateModal} from "../CourseClassStudentForm";
import {course_editStudentFromCourseClass_Api} from "../../../../../apis";
import {NotificationActionTypes, successNotify} from "../../../factory/createNotification";
import useAsyncAction from "../../../../../modules/asyncCache/useAsyncAction";
import {notifyOnError} from "../../../factory/createErrorEvent";
import {EntityPaginationMeta} from "../../../EntityList";
import {BiSolidEdit} from "react-icons/bi";
import {SubClassTags} from "../../components/SubClassTags";
import {renderStudentCard} from "../../../../Workspace/Course/functions/renderCourseClassStudent";
import {PiUserListFill} from "react-icons/pi";
import {FaIdCard} from "react-icons/fa6";
import {StudentInformationFull} from "../../Student/components/StudentInformationFull";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import getLinkToDetail from "../../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {DoubleValueItem} from "../../../CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInformation} from "../../../Organization/OrganizationEntity";
import {GoDotFill} from "react-icons/go";
import {formatDate, renderFromToTime} from "../../../../../helpers/datetimeHelpers";
import LoadingBlock from "../../../../LoadingBlock";

const DetailModalContent = ({item, courseClassStudent}) => {
    const t = useTranslate()
    const {student_subject_results = [], course_students = []} = item ?? {}
    const {registered_subjects = [], sub_class_name} = courseClassStudent ?? {}
    const [current, setCurrent] = useState('0')
    const _course_student = _.find(course_students, {
        course: {
            id: courseClassStudent?.course?.id
        }
    })

    return (
        <div className="flex flex-col gap-1">
            <StudentInformationFull student={item}/>
            <Tabs
                centered
                defaultActiveKey="0"
                onChange={setCurrent}
                size="small"
                tabBarStyle={{margin: '0 0 12px 0'}}
                className="mt-3 custom-class-tabs"
                items={[
                    {
                        key: "0",
                        label: t("information"),
                        children: (
                            <div className="space-y-3">
                                {renderIf(
                                    sub_class_name,
                                    <ItemInformation
                                        showIcon
                                        label="subclass title"
                                        value={sub_class_name}
                                        className="text-sm"
                                    />
                                )}
                                {renderIf(
                                    registered_subjects?.length,
                                    <div className="space-x-1 text-sm">
                                        <GoDotFill size={10} className="text-color-400"/>
                                        <span className="text-color-400 italic">{`${t(
                                            "registered subjects"
                                        )} : `}</span>
                                        {registered_subjects.map((e, i) => (
                                            <span key={i} className="font-bold text-color-100">
                                    {e?.title}{" "}
                                                {i < registered_subjects.length - 1 && ", "}
                                </span>
                                        ))}
                                    </div>
                                )}
                                {renderMetadata(_course_student?.metadata ?? [], false)}
                                {renderIf(
                                    course_students?.notes,
                                    <div className="flex items-baseline gap-2 text-sm">
                                        <span className="text-color-400 italic">{`${t("note")} : `}</span>
                                        <span className="font-bold text-color-100">
                                {courseClassStudent?.notes}
                            </span>
                                    </div>
                                )}
                            </div>
                        ),
                    },
                    {
                        key: "1",
                        label: t("courses"),
                        children: (
                            <div className="space-y-3">
                                {renderIf(
                                    course_students.length > 0,
                                    course_students.map((e, i) => {
                                        const {
                                            course,
                                            course_class,
                                            medal_awards,
                                            result_date,
                                            result_status,
                                        } = e ?? {};

                                        let label_status;
                                        let color_status;
                                        switch (result_status) {
                                            case 1:
                                                label_status = "passed";
                                                color_status = "text-green-600";
                                                break;
                                            case 0:
                                                label_status = "failed";
                                                color_status = "text-red-600";
                                                break;
                                            default:
                                                label_status = "not assessed yet";
                                                color_status = "text-color-300";
                                                break;
                                        }

                                        return (
                                            <div
                                                key={i}
                                                className="flex flex-col py-2 custom-render-border rounded-md relative"
                                            >
                                                <Link
                                                    to={getLinkToDetail(course)}
                                                    className="font-bold text-sm text-color-000 no-underline"
                                                >
                                                    {getTitle(course)}
                                                </Link>
                                                <DoubleValueItem
                                                    labelFirst="learn in the class"
                                                    valueFirst={getTitle(course_class)}
                                                    valueSecond={`(${t("from date")} ${formatDate(
                                                        course_class?.from_date,
                                                        "DD/MM/YYYY"
                                                    )} ${t("to date")} ${formatDate(
                                                        course_class?.to_date,
                                                        "DD/MM/YYYY"
                                                    )})`}
                                                    className="text-xs italic"
                                                />
                                                {renderIf(
                                                    medal_awards?.length,
                                                    <div className="flex flex-col gap-1">
                                            <span className="space-x-1 text-xs text-color-400 italic underline">
                                                {`${t("certification awarded")} : `}
                                            </span>
                                                        {medal_awards.map((e, i) => (
                                                            <div
                                                                key={i}
                                                                className="ml-2 flex items-center gap-2"
                                                            >
                                                                {renderIf(
                                                                    e?.medal?.avatar,
                                                                    <ImageLoader
                                                                        src={e?.medal?.avatar}
                                                                        style={{width: 30, height: 25}}
                                                                    />
                                                                )}
                                                                <div className="flex flex-col">
                                                        <span
                                                            className="font-bold text-xs text-primary italic leading-snug">
                                                            {getTitle(e.medal)}
                                                        </span>
                                                                    {renderIf(
                                                                        e?.eff_date,
                                                                        <span
                                                                            className="text-2xs text-primary italic text-color-300 leading-snug">
                                                                {renderFromToTime(e?.eff_date)}
                                                            </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                {renderIf(
                                                    result_status !== null,
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 10,
                                                            right: 10,
                                                        }}
                                                        className={classNames(
                                                            "font-bold text-xs tracking-wide uppercase opacity-70",
                                                            color_status
                                                        )}
                                                    >
                                            {t(label_status)}
                                        </span>
                                                )}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        ),
                    },
                    {
                        key: "2",
                        label: t("subject results"),
                        children: (
                            <div className="space-y-3">
                                {renderIfElse(
                                    student_subject_results.length > 0,
                                    student_subject_results.map((e, i) => {
                                        const {
                                            subject,
                                            course_class,
                                            result_date,
                                            result_status,
                                            score_type,
                                            score_text,
                                            score_number,
                                        } = e ?? {};

                                        let label_status;
                                        let color_status;
                                        switch (result_status) {
                                            case 1:
                                                label_status = "passed";
                                                color_status = "text-green-600";
                                                break;
                                            case 0:
                                                label_status = "failed";
                                                color_status = "text-red-600";
                                                break;
                                            default:
                                                label_status = "not assessed yet";
                                                color_status = "text-color-300";
                                                break;
                                        }

                                        return (
                                            <div
                                                key={i}
                                                className="py-2 flex flex-col gap-1 custom-render-border relative"
                                            >
                                    <span className="font-bold text-sm text-color-000">
                                        {getTitle(subject)}
                                    </span>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2">
                                                    {renderIf(
                                                        _.some([score_text, score_number > 0]),
                                                        <div className="space-x-1 text-xs italic">
                                                <span className="text-color-400">{`${t(
                                                    "score"
                                                )} : `}</span>
                                                            <span className="font-bold text-color-100">
                                                    {renderIfElse(
                                                        score_type === "text",
                                                        score_text,
                                                        score_number
                                                    )}
                                                </span>
                                                        </div>
                                                    )}
                                                    <div className="space-x-1 text-xs italic">
                                            <span className="text-color-400">{`${t(
                                                "result date"
                                            )} : `}</span>
                                                        <span className="font-bold text-color-100">
                                                {renderIfElse(
                                                    result_date,
                                                    formatDate(result_date, "DD/MM/YYYY"),
                                                    t("not update")
                                                )}
                                            </span>
                                                    </div>
                                                </div>
                                                <div className="space-x-1 text-xs text-color-400 italic">
                                                    <span>{t("learn in the class")}</span>
                                                    <span className="font-bold text-color-100">
                                            {getTitle(course_class)}
                                        </span>
                                                    <span>{t("in the course")}</span>
                                                    <span className="font-bold text-color-000">
                                            {getTitle(course_class?.course)}
                                        </span>
                                                    <span className="font-medium text-color-300">
                                            (
                                                        {renderFromToTime(
                                                            course_class?.from_date,
                                                            course_class?.to_date
                                                        )}
                                                        )
                                        </span>
                                                </div>
                                                {renderIf(
                                                    result_status !== null,
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: 10,
                                                            right: 10,
                                                        }}
                                                        className={classNames(
                                                            "font-bold text-xs tracking-wide uppercase opacity-70",
                                                            color_status
                                                        )}
                                                    >
                                            {t(label_status)}
                                        </span>
                                                )}
                                            </div>
                                        );
                                    }),
                                    <EmptyHolder/>
                                )}
                            </div>
                        ),
                    },
                ]}
            />

        </div>
    )
}

const CourseClassStudentTab = ({}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {item} = useContext(CourseClassContext)
    const [sub_class_name, setSubClassName] = useState()

    const [current, setCurrent] = useState('0')
    const {edit} = item ?? {}

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const course_class_id = getId(item)

    const apiInfo = course_getCourseClassStudents_Api

    const refreshKey = useMemo(
        () => [
            apiInfo.path.replace(':id', course_class_id),
            sub_class_name
        ].join('/'),
        [course_class_id, sub_class_name]
    )

    const onCancel = () => {
        setAction({})
    }

    const onError = notifyOnError(t)
    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_editStudentFromCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onCancel();
        },
    })

    const modal = useMemo(() => {
        const {student} = action?.value ?? {}
        const id = getId(student)
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        let params = {}
        let modal_params = {}

        switch (action?.type) {
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
                return (
                    <FullSideModalLayout
                        right={true}
                        onCancel={onCancel}
                        title={createModalTitle('attendance tracking')}>
                        <CourseClassStudentAttendantsForm
                            courseClass={item}
                            student={student}
                        />
                    </FullSideModalLayout>
                )
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
                params = {
                    courseClassStudent: action?.value,
                    source: 'CourseClassStudentTab',
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {
                            id: action?.value?.id,
                        })
                    },
                }
                modal_params = {
                    width: 768,
                    title: (
                        <div className="text-center font-bold text-sm text-color-000 uppercase">
                            {t('update student information in the class')}
                        </div>
                    ),
                }
                Content = CourseClassStudentUpdateModal
                break
            case CRUD.READ:
                params = {
                    courseClassStudent: action?.value
                }
                modal_params = {
                    width: 600,
                    footer: undefined,
                    cancelText: t('close'),
                    okButtonProps: {
                        hidden: true,
                    },
                    cancelButtonProps: {
                        className: 'text-color-400 button-rounded-lg no-border',
                    },
                    title: (
                        <div className="text-center font-bold text-sm md:text-lg text-color-000 uppercase">
                            {t('student information')}
                        </div>
                    ),
                }
                Content = DetailModalContent
                Wrapper = withProps({id})(FetchStudentById)
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action])

    const renderActions = useCallback(
        (item) =>
            renderIf(
                edit,
                <div
                    onClick={() => {
                        setAction({type: CRUD.READ, value: item})
                    }}
                    className="text-right text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                    {`${t('view detail')}...`}
                </div>
            ),
        [edit]
    )

    const handleAction = (action, params) => {
        const id = params?.id
        switch (action) {
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'update info in course',
                        key: StudentActionTypes.STUDENT_IN_COURSE_UPDATE,
                    },
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendance tracking',
                        key: StudentActionTypes.STUDENT_ATTENDANCE_TRACKING,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    return (
        <div className="flex flex-col">
            <Tabs
                className="custom-tabs-student"
                type="card"
                centered={false}
                tabBarGutter={8}
                defaultActiveKey="0"
                onChange={setCurrent}
                items={[
                    {
                        key: "0",
                        className: "space-y-3",
                        label: (
                            <span className="flex items-center gap-2">
                                <PiUserListFill size={14}/>
                                <span className="font-medium leading-tight">
                                    {t("list of students")}
                                </span>
                            </span>
                        ),
                        children: (
                            <>
                                <SubClassTags
                                    items={_.get(item, "sub_class_names", [])}
                                    selected={sub_class_name}
                                    setSelected={setSubClassName}
                                />
                                <div className="flex flex-col gap-3">
                                    <EntityList
                                        key={refreshKey}
                                        apiInfo={apiInfo}
                                        refreshKey={refreshKey}
                                        RenderEntity={React.Fragment}
                                        PaginationMeta={EntityPaginationMeta}
                                        query={bindQueryParam({id: course_class_id})}
                                        values={{sub_class_name}}
                                        renderItem={renderCourseClassStudent({
                                            detail: edit,
                                            renderActions,
                                            renderContextMenu,
                                        })}
                                    />
                                </div>
                            </>
                        ),
                    },
                    ...(item?.edit
                        ? [
                            {
                                key: "1",
                                className: "space-y-3",
                                label: (
                                    <div className="flex items-center gap-2">
                                        <FaIdCard size={14}/>
                                        <span className="font-medium leading-tight">
                                            {t("student card")}
                                        </span>
                                    </div>
                                ),
                                children: (
                                    <div
                                        style={{justifyItems: isSm && "center"}}
                                        className="grid grid-cols-1 md:grid-cols-3 gap-3"
                                    >
                                        <EntityList
                                            key={refreshKey}
                                            apiInfo={apiInfo}
                                            refreshKey={refreshKey}
                                            RenderEntity={React.Fragment}
                                            PaginationMeta={EntityPaginationMeta}
                                            query={bindQueryParam({id: course_class_id})}
                                            renderItem={renderStudentCard({
                                                course_class: item,
                                            })}
                                        />
                                    </div>
                                ),
                            },
                        ]
                        : []),
                ]}
            />

            {modal}
        </div>
    )
}

export default CourseClassStudentTab
